import { ToolsService } from "./../services/migrate/tools.service";

import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError, from } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { handleUnauthorizedRedirect } from "../utils/unauthorized-handler";
import { refreshWso2TokenOnce } from "../utils/wso2-token-refresh";
import {
  isInsufficientAuthError,
  isStepUpRequestUrl,
} from "../services/step-up-errors";

@Injectable({
  providedIn: "root",
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private tools: ToolsService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const isOauthTokenRequest =
          req.url.indexOf("/oauth2/") > -1 || req.url.indexOf("/token") > -1;
        const isStepUpRequest = isStepUpRequestUrl(req.url);

        if (isStepUpRequest || isInsufficientAuthError(error)) {
          return throwError(error);
        }

        if (error?.status === 401 && !isOauthTokenRequest) {
          if (req.headers.get("x-401-retry") === "1") {
            handleUnauthorizedRedirect();
            return throwError(error);
          }

          return from(refreshWso2TokenOnce()).pipe(
            switchMap((newToken) => {
              const retriedRequest = req.clone({
                setHeaders: {
                  Authorization: "Bearer " + newToken,
                  "x-401-retry": "1",
                },
              });
              return next.handle(retriedRequest);
            }),
            catchError(() => {
              handleUnauthorizedRedirect();
              return throwError(error);
            })
          );
        }

        this.tools.builder().spinner.hide();
        this.tools
          .builder()
          .openToast.emit(
            error?.error?.message
              ? error?.error?.message
              : "Desculpe ocorreu um erro inesperado"
          );
        return throwError(error);
      })
    );
  }
}
